import { render } from "./Inventory_TransferPrint_Dialog.vue?vue&type=template&id=19fcdeaa&scoped=true&ts=true"
import script from "./Inventory_TransferPrint_Dialog.vue?vue&type=script&lang=ts"
export * from "./Inventory_TransferPrint_Dialog.vue?vue&type=script&lang=ts"

import "./Inventory_TransferPrint_Dialog.vue?vue&type=style&index=0&id=19fcdeaa&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19fcdeaa"]])

export default __exports__